/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { parseBackendErrors } from "../../../helpers/parseBackendErrors";
import { createBankAccount } from "./../../../helpers/banking";
import { getCurrentUser } from "./../../../helpers/user";
import { setUser } from "./../../../store/actions/app.js";
import { useSelector, useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import { Alert, Button, TextField, Typography } from "@mui/material";
import { useForm, Controller } from "react-hook-form";
import { Link } from "react-router-dom";

const Create = (props) => {
  // state
  const [submitting, setSubmitting] = useState(false);

  // redux
  const { app } = useSelector((state) => state);
  const dispatch = useDispatch();

  // hooks
  const { control, handleSubmit, errors, setValue } = useForm();
  const { enqueueSnackbar } = useSnackbar();

  // lifecycles
  useEffect(() => {
    if(app.user && app.user.profile) {
      setValue("first_name", app.user.profile.first_name)
      setValue("last_name", app.user.profile.last_name)
    }
  },[app.user])

  // methods
  const handleBankAccountCreate = async (form) => {
    setSubmitting(true);
    const [error,] = await createBankAccount(
      app.token,
      form
    );
    setSubmitting(false);
    if (error) {
      const parsed_errors = parseBackendErrors(error.response);
      enqueueSnackbar(parsed_errors, {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "center",
        },
      });
      return;
    }
    handleGetProfile(app.token);
    enqueueSnackbar("Success! Your bank information has been added.", {
      variant: "success",
      anchorOrigin: {
        vertical: "top",
        horizontal: "center",
      },
    });
    props.history.push(`/dashboard/bank`);
  };

  const handleGetProfile = async (token) => {
    const [error, response] = await getCurrentUser(token);
    if (error) return;
    dispatch(setUser(response.data));
  };

  return (
    <>
      <Typography variant="h6" className="mb-3">
        Add Bank Account
      </Typography>
      <div className="row">
        <div className="col-xl-6 col-lg-8 col-md-8 col-sm-10 col-12">
          {
            !app.user.profile && (
              <Alert severity="error" className="mb-3">
                Attention! In order to continue, please provide additional information.
                <div>
                  <Button 
                    component={Link}
                    to="/dashboard/profile"
                    color="secondary" 
                    size="small" 
                    variant="outlined" 
                    className="mt-2"
                    >
                    Continue
                  </Button>
                </div>
              </Alert>
            ) 
          }
          <form onSubmit={handleSubmit(handleBankAccountCreate)}>
            <div className="row">
              <div className="col-6">
                <Controller
                  as={
                    <TextField
                      label="First Name *"
                      autoComplete="new-password"
                      fullWidth={true}
                      variant="outlined"
                      error={errors.first_name && true}
                      helperText={errors?.first_name?.message}
                      className="mb-3"
                      inputProps={{ maxLength: 55 }}
                    />
                  }
                  name="first_name"
                  control={control}
                  defaultValue={""}
                  rules={{
                    required: "This field is required.",
                  }}
                />
              </div>
              <div className="col-6">
                <Controller
                  as={
                    <TextField
                      label="Last Name *"
                      autoComplete="new-password"
                      fullWidth={true}
                      variant="outlined"
                      error={errors.last_name && true}
                      helperText={errors?.last_name?.message}
                      className="mb-3"
                      inputProps={{ maxLength: 55 }}
                    />
                  }
                  name="last_name"
                  control={control}
                  defaultValue={""}
                  rules={{
                    required: "This field is required.",
                  }}
                />
              </div>
            </div>
            <Controller
              as={
                <TextField
                  label="Bank Routing Number *"
                  autoComplete="new-password"
                  fullWidth={true}
                  variant="outlined"
                  error={errors.bank_routing && true}
                  helperText={errors?.bank_routing?.message}
                  className="mb-3"
                  inputProps={{ maxLength: 55 }}
                />
              }
              name="bank_routing"
              control={control}
              defaultValue={""}
              rules={{
                required: "This field is required.",
              }}
            />
            <Controller
              as={
                <TextField
                  label="Account Number *"
                  autoComplete="new-password"
                  fullWidth={true}
                  variant="outlined"
                  error={errors.bank_account && true}
                  helperText={errors?.bank_account?.message}
                  className="mb-3"
                  inputProps={{ maxLength: 55 }}
                />
              }
              name="bank_account"
              control={control}
              defaultValue={""}
              rules={{
                required: "This field is required.",
              }}
            />
            <Button
              disabled={submitting || !app.user.profile}
              size="large"
              variant="contained"
              color="primary"
              type="submit"
            >
              Add Bank Account
            </Button>
          </form>
        </div>
      </div>
    </>
  );
};
export default Create;
